import React from 'react'
import BottomAppBarItem, { BottomAppBarItemProps } from '../BottomAppBarItem'
import { NavLink, NavLinkProps } from 'react-router-dom'
import classnames from 'classnames'
import styles from './styles.css'

interface BottomAppBarLinkItemProps extends NavLinkProps, Pick<BottomAppBarItemProps, 'grow'> {
  icon: React.FunctionComponent<React.SVGAttributes<SVGElement>>
  iconClassName?: string
  itemClassName?: string
  badge?: string
}

const BottomAppBarLinkItem: React.SFC<BottomAppBarLinkItemProps> = ({
  className,
  itemClassName,
  activeClassName,
  iconClassName,
  icon: Icon,
  badge,
  grow,
  children,
  ...rest
}) => {
  return (
    <BottomAppBarItem grow={grow} className={itemClassName}>
      <NavLink
        className={classnames(styles.link, className)}
        activeClassName={classnames(styles.linkActive, activeClassName)}
        {...rest}
      >
        <Icon className={classnames(styles.linkIcon, iconClassName)} />
        {badge && <div className={styles.linkIconBadge}>{badge}</div>}
        {children}
      </NavLink>
    </BottomAppBarItem>
  )
}

export default BottomAppBarLinkItem
